import { HeaderDesktop } from "@/components/site/HeaderDesktop";
import { HeaderMobile } from "@/components/site/HeaderMobile";

interface HeaderProps {
  variant?: "default" | "shop";
}

/**
 * Twee losse headers gebundeld:
 * - `HeaderDesktop` — zichtbaar op `lg` en breder (desktop + iPad landscape/tablet)
 * - `HeaderMobile` — zichtbaar onder `lg` (mobiele telefoons)
 *
 * Beide componenten zijn onafhankelijk: aanpassingen aan `HeaderMobile.tsx`
 * raken de desktop/tablet header niet en andersom.
 */
export function Header({ variant = "default" }: HeaderProps) {
  return (
    <>
      <HeaderDesktop />
      <HeaderMobile />
      <span className="hidden" data-variant={variant} />
    </>
  );
}
